module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-a4e4bbaa.png";